// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"245":"lazy","508":"dev"}[chunkId] + "." + {"245":"49650092","508":"197c993e"}[chunkId] + ".js";
};